import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconThumbUp = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconThumbUp",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M840-640q32 0 56 24t24 56v80l-1 15q-1 8-5 15L794-168q-9 20-30 34t-44 14H400q-33 0-56-23t-24-57v-407q0-16 7-30t17-26l217-216q15-14 36-17t39 7 28 28 3 37l-45 184zM160-120q-33 0-56-23t-24-57v-360q0-33 24-56t56-24 57 24 23 56v360q0 33-23 57t-57 23"
  })
}));
IconThumbUp.displayName = 'IconThumbUp';